import { Product } from "~app/shopping-cart/product";

export class AddProductToCart {
  static readonly type = '[Cart] AddProductToCart';
  constructor(public data: Product, public quantity = 1) {}
}

export class ClearCart {
  static readonly type = '[Cart] ClearCart';
  constructor() {}
}